// extracted by mini-css-extract-plugin
export var addToCartButton = "_tf-b";
export var arrowButtonContainer = "_tf-9";
export var arrowButtonIcon = "_tf-a";
export var carouselArrowButton = "_tf-6";
export var carouselElementContainer = "_tf-1";
export var left = "_tf-7";
export var productDisplayCarouselContainer = "_tf-0";
export var productTileContainer = "_tf-2";
export var productTileImage = "_tf-4";
export var productTileImageContainer = "_tf-3";
export var productTileTitle = "_tf-5";
export var right = "_tf-8";
export var sliderOverflow = "_tf-c";